import React from 'react';
import { StylovyzeComposableDialog } from '@innovyze/stylovyze/lib/components';
import ContactUsMessage from './ContactUsMessage';
import { useGlobalization } from '../../contexts';
export default function ExpiredTenantDialog({ open, loading, }) {
    const { t } = useGlobalization();
    return (React.createElement(StylovyzeComposableDialog, { title: "No active subscription", open: !loading && open, onCancel: () => {
            return;
        }, dialogProps: {
            container: () => document.getElementById('inno-app-body'),
            style: { position: 'relative', width: '100%' },
            BackdropProps: { style: { position: 'absolute' } },
        } },
        React.createElement("div", { "data-cy": "no-subscription-dialog", style: { width: 552, maxWidth: '100%' } },
            t(
            // eslint-disable-next-line quotes
            "You don't have an active subscription. "),
            React.createElement(ContactUsMessage, null))));
}
